import { Link } from "react-router-dom";
import { Section, FadeIn } from "@/components/Section";
import { ArrowRight } from "lucide-react";

export default function FinalCta() {
  return (
    <Section testId="final-cta-section" className="bg-white">
      <FadeIn>
        <div className="relative overflow-hidden rounded-3xl bg-slate-900 text-white p-10 lg:p-16">
          <span className="absolute -top-40 -right-20 w-[500px] h-[500px] rounded-full bg-blue-500/20 blur-3xl" />
          <span className="absolute bottom-[-10rem] left-[-5rem] w-[420px] h-[420px] rounded-full bg-indigo-500/15 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-300 mb-4">Final step</div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
                See how clinics are deploying high-margin cash-pay programs.
              </h2>
              <p className="mt-5 text-slate-300 max-w-2xl leading-relaxed">
                Book a 30-minute walkthrough of the platform — curated programs, workflow automation, vendor coordination, and recurring revenue infrastructure.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-wrap gap-3 justify-start lg:justify-end">
              <Link
                to="/demo"
                data-testid="final-cta-book-demo-btn"
                className="inline-flex items-center gap-2 bg-white text-slate-900 rounded-full px-6 py-3.5 text-sm font-semibold hover:bg-slate-100 transition-colors"
              >
                Book a Demo <ArrowRight className="w-4 h-4" />
              </Link>
              <Link
                to="/request-access"
                data-testid="final-cta-request-access-btn"
                className="inline-flex items-center gap-2 border border-white/20 rounded-full px-6 py-3.5 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
              >
                Request portal access
              </Link>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>
  );
}
